import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPageText: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPageText"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2H20V22H4V2ZM8 6V8H16V6H8ZM8 10V12H16V10H8ZM8 14V16H12V14H8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPageText;
